import "./CompanyReports.css";
import { useCallback, useEffect, useState, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { HiOutlineDocumentReport } from "react-icons/hi";
import GeneratePayslip from "../../settingBody/GeneratePayslip/GeneratePayslip"; // adjust path as needed

import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";

import CSV_FILE from "../../../assets/files/csv_file.csv";

import {
  commonGetData,
  commonGetDataOne,
  commonSaveData,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import {
  fetchBranchData,
  initBranchState,
} from "../../../redux/slices/branchSlice";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../../redux/slices/departmentSlice";
import {
  fileSaveData,
  fileListData,
  fileInitState,
} from "../../../redux/slices/uploadFiles";
import {
  getReportTypePath,
  customAttendancePath,
  reportGenerationPath,
  reportGenerationListPath,
} from "../../../services/config";
import {
  downloadCSV1,
  formattedReport,
  getCapitalizeWord,
} from "../../../services/commonServices";
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import CustomPagination from "../../../components/CustomPagination";
import { HasPermission } from "../../../services/hasPermission";

const paginationPageSize = 10;
const paginationPageSizeSelector = [10, 20, 50, 100];
const ManagementTab = ["Attendance", "Payroll", "Notes", "Employee List", "Payslip"];

const CompanyReports = () => {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const dispatch = useDispatch();

  // State management
  const [state, setState] = useState({
    reportList: [],
    reportTypeList: [],
    branchList: [],
    departmentList: [],
    reportType: "",
    branchIdName: "",
    branchId: "",
    branchName: "",
    departmentId: "",
    fromDate: "",
    toDate: "",
    highlightTap: 0,
  });

  const [isPayrollAttendance, setIsPayrollAttendance] = useState(false)

  // Redux state selectors
  const commonState = useSelector((state) => state.common);
  const branchState = useSelector((state) => state.branch);
  const departmentState = useSelector((state) => state.department);
  const fileUploadStore = useSelector((state) => state.fileUpload);
  const themeStore = useSelector((state) => state.theme)

  const [cssVars, setCssVars] = useState({
    borderColor: "",
    textColor: "",
  });

  useEffect(() => {
    // DOM se value client-side pe le rahe hain
    setCssVars({
      borderColor: themeStore.theme == "light" ? "#0e0e0e" : "#8660F8",
      textColor: themeStore.theme == "light" ? "#0e0e0e" : "#fff",
    });
  }, []);

  const tabStyle = useMemo(
    () => ({
      position: "relative",
      top: "6px",
      borderBottom: `2px solid ${cssVars.borderColor}`,
      fontSize: "13px",           // ← add this
      fontFamily: "'Outfit'",

      color: cssVars.textColor,
    }),
    [cssVars]
  );

  // Memoized values


  const tabStyle1 = useMemo(
    () => ({
      color: themeStore.theme == "light" ? "#484747b2" : "#fff",
      position: "relative",
      fontSize: "13px",           // ← add this
      fontFamily: "'Outfit'",
      top: "6px",
    }),
    [cssVars]
  );

  // Data fetching functions
  const getList = useCallback(() => {
    dispatch(
      fileListData({
        path: reportGenerationListPath,
        data: { userId: user.user_id },
      })
    );
  }, [user.user_id, dispatch]);

  const getReport = useCallback(() => {
    dispatch(commonGetData(`${getReportTypePath}${state.highlightTap + 1}`));
    dispatch(fetchDepartmentData(user.user_id));
    dispatch(fetchBranchData());
  }, [state.highlightTap, user.user_id, dispatch]);

  // Initial data load
  useEffect(() => {
    getList();
    getReport();
  }, [getList, getReport]);

  // Handle state updates from Redux
  useEffect(() => {
    const updates = {};

    if (commonState.commonGetSuccess) {
      updates.reportTypeList = commonState.commonGetData;
      dispatch(initCommonState());
    }
    if (branchState.brnGetSuccess) {
      updates.branchList = branchState.brnGetData;
      dispatch(initBranchState());
    }
    if (departmentState.depGetSuccess) {
      updates.departmentList = departmentState.depGetData;
      dispatch(initDepartState());
    }
    if (fileUploadStore.fileListSuccess) {
      updates.reportList = fileUploadStore.fileListData;
      dispatch(fileInitState());
    }
    if (fileUploadStore.fileSuccess) {
      dispatch(fileInitState());
      getList();
    }

    if (Object.keys(updates).length > 0) {
      setState((prev) => ({ ...prev, ...updates }));
    }
  }, [
    commonState,
    branchState,
    departmentState,
    fileUploadStore,
    dispatch,
    getList,
  ]);

  // Handle report generation
  const submitReportAndGenerateCsv = useCallback(() => {
    if (!state.reportType) {
      toast.error("Report type is required");
      return;
    }

    dispatch(
      commonSaveData({
        path: customAttendancePath,
        data: {
          userId: user.user_id,
          fromDate: state.fromDate,
          toDate: state.toDate,
          branchId: state.branchId,
          shiftId: "",
          departmentId: state.departmentId,
          reportType: state.reportType,
        },
      })
    );
  }, [state, user.user_id, dispatch]);

  // Handle report generation response
  useEffect(() => {
    if (!commonState.commonSuccess && !commonState.commonError) return;

    if (commonState.commonSuccess) {
      toast.success(commonState.commonMessage);

      const data = commonState.commonData.dailyAttendanceData;
      if (data?.length) {
        const fData = formattedReport(data);
        const csvData = downloadCSV1(
          fData,
          `Attendance_Summary_${state.fromDate}.csv`
        );

        const file = new File(
          [csvData],
          `Attendance_Summary_${state.fromDate}.csv`,
          {
            type: "application/csv;charset=utf-8;",
          }
        );

        const formData = new FormData();
        formData.append("userId", user.user_id);
        formData.append("reportType", state.reportType);
        formData.append("branchName", state.branchName);
        formData.append("duration", `${state.fromDate}-${state.toDate}`);
        formData.append("format", "csv");
        formData.append("supportingFile", file);
        formData.append(
          "base64FileName",
          `Attendance_Summary_${state.fromDate}.csv`
        );

        dispatch(
          fileSaveData({
            path: reportGenerationPath,
            data: formData,
          })
        );
      }
    } else if (commonState.commonError) {
      toast.error(commonState.commonMessage);
    }

    dispatch(initCommonState());
  }, [commonState, dispatch, state, user.user_id]);

  const handleBranchChange = useCallback((value) => {
    const [id, name] = value.split("|");
    setState((prev) => ({
      ...prev,
      branchId: id,
      branchName: name,
      branchIdName: value,
    }));
  }, []);

  const handleInputChange = useCallback((field, value) => {
    if (field == "highlightTap") {
      setState((pre) => ({
        ...pre,
        reportType: "",
        branchIdName: "",
        branchId: "",
        branchName: "",
        departmentId: "",
        fromDate: "",
        toDate: "",
      }));
      setIsPayrollAttendance(false)
    }
    setState((prev) => ({ ...prev, [field]: value }));
  }, []);

  const handlePayrollAttendance = ({ target: { checked } }) => {
    setIsPayrollAttendance(checked)
  }

  const filteredReportTypes = useMemo(
    () =>
      state.reportTypeList.filter(
        (row) => row.report_name === "Attendance Summary Report"
      ),
    [state.reportTypeList]
  );

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />

      <Widgets
        icon={
          <WidgetsIcon
            icon={
              <Link
                to={location.pathname !== "/reports" ? "/setting/" : "#"}
                className="icon-color"
              >
                {location.pathname !== "/reports" ? (
                  <ArrowBackIcon />
                ) : (
                  <HiOutlineDocumentReport
                    style={{ position: "relative", top: "-3px" }}
                  />
                )}
              </Link>
            }
            title="Company Report"
          />
        }
        body={
          <div className="CompanyReports-body">
            <div className="CompanyReportsForm">
              <div className="EmployeeManagementTab">
                {ManagementTab.map((item, i) => (
                  <p
                    key={i}
                    style={state.highlightTap === i ? tabStyle : tabStyle1}
                    onClick={() => handleInputChange("highlightTap", i)}
                  >
                    {item}
                  </p>
                ))}
              </div>

              {state.highlightTap !== 4 && (
                <>
                  <form>
                    <div className="CompanyReports-input" style={{ width: "220px" }}>
                      <label>Report Type</label>
                      <select
                        value={state.reportType}
                        onChange={(e) => handleInputChange("reportType", e.target.value)}
                        className="dropdown universal-input"
                      >
                        <option value="">Select Report Type</option>
                        {filteredReportTypes.map((row, idx) => (
                          <option value={row.report_name} key={idx}>{row.report_name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="CompanyReports-input">
                      <label>Select Branch</label>
                      <select
                        value={state.branchIdName}
                        onChange={(e) => handleBranchChange(e.target.value)}
                        className="dropdown universal-input"
                      >
                        <option value="">Select Branch</option>
                        {state.branchList.map((row, idx) => (
                          <option key={idx} value={`${row.branchId}|${row.branch_name}`}>{row.branch_name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="CompanyReports-input">
                      <label>Select Department</label>
                      <select
                        value={state.departmentId}
                        onChange={(e) => handleInputChange("departmentId", e.target.value)}
                        className="dropdown universal-input"
                      >
                        <option value="">Select Department</option>
                        {state.departmentList.map((row, idx) => (
                          <option key={idx} value={`${row.departmentId}|${row.department_name}`}>{row.department_name}</option>
                        ))}
                      </select>
                    </div>

                    {state.highlightTap !== 3 && (
                      <>
                        <div className="CompanyReports-input">
                          <label>From Date</label>
                          <input type="date" value={state.fromDate}
                            onChange={(e) => handleInputChange("fromDate", e.target.value)}
                            className="universal-input" />
                        </div>
                        <div className="CompanyReports-input">
                          <label>To Date</label>
                          <input type="date" value={state.toDate}
                            onChange={(e) => handleInputChange("toDate", e.target.value)}
                            className="universal-input" />
                        </div>
                      </>
                    )}

                    <div className="CompanyReports-input">
                      <label>Format</label>
                      <input value={state.highlightTap === 3 ? "pdf" : "csv"} readOnly className="universal-input" />
                      <div id="ReportType-checkbox">
                        <input type="checkbox" checked={isPayrollAttendance} onChange={handlePayrollAttendance} />
                        <label className="color-gray">Payroll Attendance</label>
                      </div>
                    </div>
                  </form>

                  {/* <div className="CompanyReports-btn">
                    {HasPermission("Reports", "export") && (
                      <div style={{ width: "200px", marginLeft: "20px" }}>
                        <button type="button" className="universal-btn" onClick={submitReportAndGenerateCsv}>
                          Generate Reports
                        </button>
                      </div>
                    )}
                    <p style={{ textAlign: "center" }}>
                      Some reports might take time to generate. Once these are done,
                      <br />
                      you can download all the report generate from the list below.
                    </p>
                  </div> */}
                </>
              )}

       {state.highlightTap !== 4 && (
                <div className="CompanyReports-btn">
                  {HasPermission("Reports", "export") && (
                    <div style={{ width: "200px", marginLeft: "20px" }}>
                      <button
                        type="button"
                        className="universal-btn"
                        onClick={submitReportAndGenerateCsv}
                      >
                        Generate Reports
                      </button>
                    </div>
                  )}
                  <p style={{ textAlign: "center" }}>
                    Some reports might take time to generate. Once these are done,
                    <br />
                    you can download all the report generate from the list below.
                  </p>
                </div>
              )}
            </div>

            {state.highlightTap === 4 ? (
              <div style={{
                width: "100%",
                minHeight: "80vh",
                overflow: "auto",
                marginTop: "10px"
              }}>
                <GeneratePayslip />
              </div>
            ) : (
              <ReportsTable reportList={state.reportList} />
            )}
          </div>
        }
      />
    </>
  );
};

const ReportsTable = ({ reportList }) => {
  const downloadCSVFile = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "report.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const columns = useMemo(
    () => [
      {
        headerName: "Report Type",
        width: "220px",
        // flex: 1,
        cellRenderer: ({ data }) => (
          <div className="cell-content">{data.reportType || "-"}</div>
        ),
      },
      {
        headerName: "Branch",
        flex: 1,
        cellRenderer: ({ data }) => (
          <div className="cell-content">{data.branchName || "-"}</div>
        ),
      },
      // {
      //   headerName: "Shift",
      //   flex: 1,
      //   cellRenderer: ({ data }) => (
      //     <div className="cell-content">{data.shiftName || "-"}</div>
      //   )
      // },
      {
        headerName: "Duration",
        flex: 1,
        cellRenderer: ({ data }) => (
          <div className="cell-content">{data.duration || "-"}</div>
        ),
      },
      {
        headerName: "Format",
        flex: 1,
        cellRenderer: ({ data }) => (
          <div className="cell-content">{data.format.toUpperCase() || "-"}</div>
        ),
      },
      {
        headerName: "Generated On",
        flex: 1,
        cellRenderer: ({ data }) => (
          <div className="cell-content">{data.created_on || "-"}</div>
        ),
      },
      {
        headerName: "Status",
        flex: 1,
        cellRenderer: ({ data }) => (
          <div className="cell-content">
            {HasPermission("Reports", "export") ? (
              data.fileName ? (
                <span
                  style={{ color: "#8660F8" }}
                  onClick={() => downloadCSVFile(data.fileName)}
                >
                  Download
                </span>
              ) : (
                <span style={{ color: "#FFBB00" }}>In Progress</span>
              )
            ) : (
              "-"
            )}

            {/* <a
              href={data.fileName}
              download="Attendance_Summary_2025-04-01.csv"
              target="_blank"
            >
              Download CSV
            </a> */}
          </div>
        ),
      },
    ],
    [downloadCSVFile]
  );

  return (
    <div className="ReportsTable-body report-tbl-bg">
      <div className="ReportsTable-head color-white">
        <p>Recent Reports</p>
        {/* <button>Refresh</button> */}
      </div>
      <div className="ReportsTable-table">
        <div
          className="ag-theme-quartz custom-grid"
          style={{
            height: "calc(100vh - 240px)",
            width: "100%",
            padding: "10px 20px",
          }}
        >
          <AgGridReact
            rowData={Array.isArray(reportList) ? reportList : []}
            columnDefs={columns}
            pagination
            paginationPageSize={paginationPageSize}
            onGridReady={onGridReady}
          />
        </div>
        <div className="d-flex align-items-center justify-content-between custom-pagination px-4">
          {gridApi && <CustomPagination gridApi={gridApi} />}
        </div>
      </div>
    </div>
  );
};

export default CompanyReports;
